// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3g9Wu","title":"Info_title____2dY","selects":"Info_selects__Jv4s1","requiredAsterisk":"Info_requiredAsterisk__1foNT"};